module.exports = require('./helpers/bundle-url').getBundleURL('7BhJl') + "simple-workflow.a19e6c0c.svg";